module.exports = __webpack_public_path__ + "static/media/03.edbf51a0.jpg";